<app-homepage-header pageName="Return Policy"></app-homepage-header>
<section class="section-wrapper privacy-policy-section-wrapper mt-120px">
  <div class="container flex-direction-column">
    <h2 class="fs-for-title mb-5">{{ 'return_policy_content.return_policy' | translate }}</h2>
    <p class="mb-5">{{ 'return_policy_content.return_policy_text' | translate }}</p>

    <div class="mb-5"><h3>{{ 'return_policy_content.return_period' | translate }}</h3>
      <p>{{ 'return_policy_content.return_period_text' | translate }}</p>
    </div>

    <div class="mb-5"><h3>{{ 'return_policy_content.return_conditions' | translate }}</h3>
      <p>{{ 'return_policy_content.return_conditions_text' | translate }}</p>
    </div>

    <div class="mb-5">
      <h3>{{ 'return_policy_content.return_refunds' | translate }}</h3>
      <p>{{ 'return_policy_content.return_refunds_text' | translate }}</p>
    </div>
    <div class="mb-5">

      <h3>{{ 'return_policy_content.return_subscriptions' | translate }}</h3>
      <p>{{ 'return_policy_content.return_subscriptions_text' | translate }}</p>
    </div>

    <div class="mb-5">
      <h3>{{ 'return_policy_content.subscription_cancellation' | translate }}</h3>
      <p>{{ 'return_policy_content.subscription_cancellation_text' | translate }}</p>
    </div>

    <div class="mb-5">
      <h3>{{ 'return_policy_content.order_cancellation' | translate }}</h3>
      <p>{{ 'return_policy_content.order_cancellation_text' | translate }}</p>
    </div>
    <div class="mb-5">

      <h3>{{ 'return_policy_content.processing_time' | translate }}</h3>
      <p>{{ 'return_policy_content.processing_time_text' | translate }}</p>
    </div>

    <div class="mb-5">
      <h3>{{ 'return_policy_content.cancellation_conditions' | translate }}</h3>
      <p>{{ 'return_policy_content.cancellation_conditions_text' | translate }}</p>
    </div>

    <div class="mb-5">
      <h3>{{ 'return_policy_content.exchanges.title' | translate }}</h3>
      <p>{{ 'return_policy_content.exchanges.description' | translate }}</p>

      <ol>
        <li>{{ 'return_policy_content.exchanges.1' | translate }}</li>
        <li>{{ 'return_policy_content.exchanges.2' | translate }}</li>
        <li>{{ 'return_policy_content.exchanges.3' | translate }}</li>
        <li>{{ 'return_policy_content.exchanges.4' | translate }}</li>
      </ol>

      <p>
        {{ 'return_policy_content.exchanges.questions' | translate }}
        <a href="tel:+37444772664">+374 44 772663</a>
        {{ 'return_policy_content.exchanges.or_email' | translate }}
        <a href="mailto:info@scanme.am">info&#64;scanme.am</a>.
      </p>
    </div>
  </div>
</section>

<div class="mt-70px">
  <app-footer></app-footer>
</div>
